module.exports = require("././angular-sanitize.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-sanitize (bower component)
 ** module id = 371
 ** module chunks = 1
 **/